// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Default Font Family */
  --scl--default-font: 'Inter', sans-serif;

  /* Default border radius */
  --scl--default-border-radius-sm: 2px;
  --scl--default-border-radius-md: 4px;
  --scl--default-border-radius-lg: 6px;
  --scl--default-border-radius-xl: 8px;

  /* Action Button Components */
  --scl--cms-components-actionButton-color: #797979;
  --scl--cms-components-actionButton-hover-color: #000000;
  --scl--cms-components-actionButton-popup-background: #FFFFFF;
  --scl--cms-components-actionButton-popup-box-shadow: rgba(0, 0, 0, 0.25);
  --scl--cms-components-actionButton-popup-item-color: #8A8B8F;
  --scl--cms-components-actionButton-popup-item-hover-background: #EFF3F8;
  --scl--cms-components-actionButton-popup-item-hover-color: #323539;
}

/* Wrapper */
.scl--cms-components-actionButton-wrapper {
  position: relative;
  display: inline-block;
}

/* ======================
   Action Button
====================== */
.scl--cms-components-actionButton {
  width: 25px;
  height: 25px;
  border: none;
  border-radius: var(--scl--default-border-radius-lg);
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--scl--cms-components-actionButton-color);
  transition: all 0.2s ease;
}

.scl--cms-components-actionButton:hover {
  background: var(--action-hover);
  color: var(--scl--cms-components-actionButton-hover-color);
}

.scl--cms-components-actionButton.hover,
.scl--cms-components-actionButton.active {
  background: var(--action-hover);
  color: var(--scl--cms-components-actionButton-hover-color);
}

.scl--cms-components-actionButton:disabled {
  cursor: default;
}

/* ======================
   Popup Container
====================== */
.scl--cms-components-actionButton-popup {
  position: absolute;
  right: 0;
  top: 100%;
  width: max-content;
  min-width: 102px;
  max-width: calc(100vw - 24px);
  white-space: nowrap;
  border-radius: var(--scl--default-border-radius-md);
  background: var(--scl--cms-components-actionButton-popup-background);
  box-shadow: 0px 4px 4px var(--scl--cms-components-actionButton-popup-box-shadow);
  padding: 4px 0px;
  display: flex;
  flex-direction: column;
  opacity: 0;
  transform: translateY(-10px);
  pointer-events: none;
  transition: opacity 0.3s ease, transform 0.3s ease;
  z-index: 9999;
}

.scl--cms-components-actionButton-popup.scl--cms-components-actionButton-popup-open {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
  width: max-content;
  min-width: 102px;
  max-width: calc(100vw - 24px);
}

.scl--cms-components-actionButton-popup-item {
  display: flex;
  border-radius: 0;
  align-items: center;
  gap: 12px;
  padding: 0px 10px;
  height: 30px;
  font-family: var(--scl--default-font);
  font-size: 14px;
  line-height: 30px;
  color: var(--scl--cms-components-actionButton-popup-item-color);
  background: transparent;
  border: none;
  cursor: pointer;
  transition: background 0.3s ease, color 0.3s ease;
}

.scl--cms-components-actionButton-popup-item:hover {
  background: var(--scl--cms-components-actionButton-popup-item-hover-background);
  color: var(--scl--cms-components-actionButton-popup-item-hover-color);
  border-radius: 0;
}

/* Icon inside popup item */
.scl--cms-components-actionButton-popup-item svg {
  width: 12px;
  height: 12px;
  flex: none;
  order: 0;
}

/* Label inside popup item */
.scl--cms-components-actionButton-popup-item span {
  flex: none;
  order: 1;
}

/* Disabled popup items */
.scl--cms-components-actionButton-popup-item:disabled {
  cursor: default;
  opacity: 0.5;
}

.scl--cms-components-actionButton,
.scl--cms-components-actionButton-popup-item {
  transition: all 0.2s ease;
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/button-fs-cp/action-button-op/css/actionButton.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,wCAAwC;;EAExC,0BAA0B;EAC1B,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;;EAEpC,6BAA6B;EAC7B,iDAAiD;EACjD,uDAAuD;EACvD,4DAA4D;EAC5D,wEAAwE;EACxE,4DAA4D;EAC5D,uEAAuE;EACvE,kEAAkE;AACpE;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;wBAEwB;AACxB;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mDAAmD;EACnD,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,0DAA0D;AAC5D;;AAEA;;EAEE,+BAA+B;EAC/B,0DAA0D;AAC5D;;AAEA;EACE,eAAe;AACjB;;AAEA;;wBAEwB;AACxB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,mDAAmD;EACnD,oEAAoE;EACpE,gFAAgF;EAChF,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,4BAA4B;EAC5B,oBAAoB;EACpB,kDAAkD;EAClD,aAAa;AACf;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,+DAA+D;EAC/D,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,+EAA+E;EAC/E,qEAAqE;EACrE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,QAAQ;AACV;;AAEA,4BAA4B;AAC5B;EACE,UAAU;EACV,QAAQ;AACV;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,yBAAyB;AAC3B","sourcesContent":[":root {\n  /* Default Font Family */\n  --scl--default-font: 'Inter', sans-serif;\n\n  /* Default border radius */\n  --scl--default-border-radius-sm: 2px;\n  --scl--default-border-radius-md: 4px;\n  --scl--default-border-radius-lg: 6px;\n  --scl--default-border-radius-xl: 8px;\n\n  /* Action Button Components */\n  --scl--cms-components-actionButton-color: #797979;\n  --scl--cms-components-actionButton-hover-color: #000000;\n  --scl--cms-components-actionButton-popup-background: #FFFFFF;\n  --scl--cms-components-actionButton-popup-box-shadow: rgba(0, 0, 0, 0.25);\n  --scl--cms-components-actionButton-popup-item-color: #8A8B8F;\n  --scl--cms-components-actionButton-popup-item-hover-background: #EFF3F8;\n  --scl--cms-components-actionButton-popup-item-hover-color: #323539;\n}\n\n/* Wrapper */\n.scl--cms-components-actionButton-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n/* ======================\n   Action Button\n====================== */\n.scl--cms-components-actionButton {\n  width: 25px;\n  height: 25px;\n  border: none;\n  border-radius: var(--scl--default-border-radius-lg);\n  background: transparent;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--scl--cms-components-actionButton-color);\n  transition: all 0.2s ease;\n}\n\n.scl--cms-components-actionButton:hover {\n  background: var(--action-hover);\n  color: var(--scl--cms-components-actionButton-hover-color);\n}\n\n.scl--cms-components-actionButton.hover,\n.scl--cms-components-actionButton.active {\n  background: var(--action-hover);\n  color: var(--scl--cms-components-actionButton-hover-color);\n}\n\n.scl--cms-components-actionButton:disabled {\n  cursor: default;\n}\n\n/* ======================\n   Popup Container\n====================== */\n.scl--cms-components-actionButton-popup {\n  position: absolute;\n  right: 0;\n  top: 100%;\n  width: max-content;\n  min-width: 102px;\n  max-width: calc(100vw - 24px);\n  white-space: nowrap;\n  border-radius: var(--scl--default-border-radius-md);\n  background: var(--scl--cms-components-actionButton-popup-background);\n  box-shadow: 0px 4px 4px var(--scl--cms-components-actionButton-popup-box-shadow);\n  padding: 4px 0px;\n  display: flex;\n  flex-direction: column;\n  opacity: 0;\n  transform: translateY(-10px);\n  pointer-events: none;\n  transition: opacity 0.3s ease, transform 0.3s ease;\n  z-index: 9999;\n}\n\n.scl--cms-components-actionButton-popup.scl--cms-components-actionButton-popup-open {\n  opacity: 1;\n  transform: translateY(0);\n  pointer-events: auto;\n  width: max-content;\n  min-width: 102px;\n  max-width: calc(100vw - 24px);\n}\n\n.scl--cms-components-actionButton-popup-item {\n  display: flex;\n  border-radius: 0;\n  align-items: center;\n  gap: 12px;\n  padding: 0px 10px;\n  height: 30px;\n  font-family: var(--scl--default-font);\n  font-size: 14px;\n  line-height: 30px;\n  color: var(--scl--cms-components-actionButton-popup-item-color);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: background 0.3s ease, color 0.3s ease;\n}\n\n.scl--cms-components-actionButton-popup-item:hover {\n  background: var(--scl--cms-components-actionButton-popup-item-hover-background);\n  color: var(--scl--cms-components-actionButton-popup-item-hover-color);\n  border-radius: 0;\n}\n\n/* Icon inside popup item */\n.scl--cms-components-actionButton-popup-item svg {\n  width: 12px;\n  height: 12px;\n  flex: none;\n  order: 0;\n}\n\n/* Label inside popup item */\n.scl--cms-components-actionButton-popup-item span {\n  flex: none;\n  order: 1;\n}\n\n/* Disabled popup items */\n.scl--cms-components-actionButton-popup-item:disabled {\n  cursor: default;\n  opacity: 0.5;\n}\n\n.scl--cms-components-actionButton,\n.scl--cms-components-actionButton-popup-item {\n  transition: all 0.2s ease;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
